import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Live from 'pages/Live'
import Stream from 'pages/Stream'
import NotFound from 'pages/NotFound'
import MagicLink from 'pages/MagicLink'

export default ({ childProps }) => (
  <Switch>
    {/* defined routes */}
    <Route path="/start/:short_code/*" component={MagicLink} />
    <Route path="/:eventId/live*" exact component={Live} />
    <Route path="/:eventId/stream" exact component={Stream} />
    {/* Finally, catch all unmatched routes */}
    <Route component={NotFound} />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/routes/index.jsx